import { Injectable } from '@angular/core';

import { FitpackManifest } from '../models/sequal.models';

/**
 * A loaded user .fitpack (ADR-0044): reference-only signed JSON — media bytes are
 * NOT in the file, they're granted + downloaded from the server at import.
 */
export interface LoadedFitpack {
  manifest: FitpackManifest;
}

@Injectable({ providedIn: 'root' })
export class ImportService {
  private current: LoadedFitpack | null = null;

  setFitpack(data: LoadedFitpack): void {
    this.current = data;
  }

  getFitpack(): LoadedFitpack | null {
    return this.current;
  }

  clear(): void {
    this.current = null;
  }
}
